var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcRemove = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 19,
  fill: "none",
  viewBox: "0 0 16 19"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#3C97AA",
  d: "M0 3h2m14 0h-2M2 3v15h12V3M2 3h3m9 0h-3M5 3c0-1 .2-2 3-2s3 1 3 2M5 3h6M5 6v10M8 6v10m3-10v10"
})));
export { SvgIcRemove as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAxNiAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAgM0gyTTE2IDNIMTRNMiAzVjE4SDE0VjNNMiAzSDVNMTQgM0gxMU01IDNDNSAyIDUuMiAxIDggMUMxMC44IDEgMTEgMiAxMSAzTTUgM0gxMU01IDZWMTZNOCA2VjE2TTExIDZWMTYiIHN0cm9rZT0iIzNDOTdBQSIvPgo8L3N2Zz4K";